import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { useTenant } from "@/contexts/TenantContext";
import { useAuth } from "@/contexts/AuthContext";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Info } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function Shell() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { isSuperAdmin, activeTenantId } = useTenant();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex bg-background">
      <Sidebar mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />
      <div className="flex-1 min-w-0 flex flex-col">
        <Header onToggleMobile={() => setMobileOpen(true)} />
        <main className="flex-1 px-4 md:px-8 py-6 md:py-10">
          {isSuperAdmin && !activeTenantId && (
            <Alert className="mb-6" data-testid="alert-select-tenant">
              <Info className="h-4 w-4" />
              <AlertTitle>Modo Super Admin VRIntegrales</AlertTitle>
              <AlertDescription className="flex items-center justify-between gap-4">
                <span className="text-sm">
                  Selecciona un tenant para operar sobre sus sucursales, usuarios, clientes y vehículos.
                </span>
                <Button
                  size="sm"
                  className="btn-tenant"
                  data-testid="btn-go-to-tenants"
                  onClick={() => navigate("/tenants")}
                >
                  Ver tenants
                </Button>
              </AlertDescription>
            </Alert>
          )}
          <Outlet />
        </main>
      </div>
    </div>
  );
}
